import { useState } from "react";

// Closing without finishing is remembered per browser so the survey doesn't nag on every page.
const key = (identifier) => `survey-dismissed:${identifier}`;

const wasDismissed = (identifier) => {
  try {
    return window.localStorage.getItem(key(identifier)) === "1";
  }
  catch(e) {
    return false;
  }
};

const rememberDismissed = (identifier) => {
  try {
    window.localStorage.setItem(key(identifier), "1");
  }
  catch(e) {
    return;
  }
};

export default function useDismissal({ identifier, remember }) {
  const [closed, setClosed] = useState(() => remember && wasDismissed(identifier));

  const close = ({ finished }) => {
    if(remember && !finished) {
      rememberDismissed(identifier);
    }
    setClosed(true);
  };

  return { close, closed };
}
